import type { IFaqResponse, IFaqSection } from './models';
import { KEGatewayClient } from '../KEGatewayClient';

export class _FaqClient extends KEGatewayClient {
  public async getFaq(): Promise<IFaqSection[]> {
    try {
      const response = await this.get<IFaqResponse>('main/about/faq/');
      return response.payload.sections;
    } catch (e) {
      console.error(e);
      return [];
    }
  }
}

export const FaqClient = new _FaqClient();
